var recaptcha = function () {

  var publicMethods = {};

	var elements = document.querySelectorAll('[data-recaptcha]:not([data-recaptcha-loaded])');

	var instances = {};

	var initialised = false;
	var loaded = false;
	var submit = false;

  publicMethods.init = function() {

    if (!elements.length) return;

		if (!initialised) {

			initialised = true;

			var script1 = document.createElement('script');
			script1.innerHTML = 'var recaptchaLoaded = function() { recaptcha.setup(); }';
			document.body.appendChild(script1);

			var script2 = document.createElement('script');
			script2.src = 'https://www.google.com/recaptcha/api.js?render=explicit&onload=recaptchaLoaded';
			document.body.appendChild(script2);

		} else {

			if (loaded) { recaptcha.setup(); }

		}

  };

  publicMethods.setup = function() {

		for (var i = 0; i < elements.length; i++) {
			
			(function (i) {
				
				var id = elements[i].getAttribute('id');
				var form = elements[i].closest('form');

				elements[i].setAttribute('data-recaptcha-loaded', true);

				instances[id] = grecaptcha.render(id, {
					'sitekey': recaptchaPublicKey,
					'size': 'invisible',
					'badge': 'inline',
					'callback': function (token) {
						submit = true;
						form.querySelector('.g-recaptcha-response').value = token;
						form.submit();
					}
				});

				form.addEventListener('submit', function(e) {

					if (!form.querySelectorAll(':invalid').length && !submit) {

						grecaptcha.execute(instances[id]);
						e.preventDefault();
						return false;

					}

				});

			})(i);
		
		}

		loaded = true;

  };

  return publicMethods;

}();

window.addEventListener('load', function() { recaptcha.init(); });
